import {
  TypographyCaption,
  TypographyCaptionBold,
} from '@heidi/design-system/typography';
import { getCurrentUserSnippets } from '@heidi/workspace/data';
import { type Editor } from '@tiptap/react';
import { type Command, type Group } from './types';

export interface SnippetActionCreator {
  (editor: Editor, snippetContent: string): void;
}

export interface CreateSnippetGroupOptions {
  editor: Editor;
  createInsertAction: SnippetActionCreator;
}

export function createSnippetGroup({
  editor,
  createInsertAction,
}: CreateSnippetGroupOptions): Group {
  const snippets = getCurrentUserSnippets();

  const snippetCommands: Command[] =
    snippets?.snippets.map((snippet) => ({
      name: snippet.shorthand,
      label: snippet.shorthand,
      description: snippet.content,
      snippetIsVerbalTrigger: snippet.is_verbal_trigger,
      snippetTriggerPhrase: snippet.trigger_phrase,
      snippetId: snippet.id,
      action: () => createInsertAction(editor, snippet.content),
      content: (
        <div className="flex w-full min-w-0 max-w-[calc(100%-28px)] gap-2">
          <TypographyCaptionBold className="inline-block w-fit max-w-[75%] shrink-0 truncate">
            {snippet.shorthand}
          </TypographyCaptionBold>
          <TypographyCaption className="truncate text-text-secondary">
            {snippet.content}
          </TypographyCaption>
        </div>
      ),
    })) ?? [];

  snippetCommands.push({
    name: 'createSnippet',
    label: '+ New snippet',
    action: () => {},
    content: (
      <TypographyCaption className="text-text-secondary">+ New snippet</TypographyCaption>
    ),
  });

  return {
    name: 'snippets',
    title: 'SNIPPETS',
    commands: snippetCommands,
  };
}
